var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32.001,
    viewBox: "0 0 32 32.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M23243.92,2696a16,16,0,1,1,11.314-4.686A15.894,15.894,0,0,1,23243.92,2696Zm3.619-16.041c2.066,0,2.066,1.964,2.066,3.4v6.24h3.975v-7.028c0-3.177-.576-6.118-4.77-6.118l-.158,0a4.2,4.2,0,0,0-3.611,2.075h-.053v-1.751h-3.812V2689.6h3.975v-6.345C23245.15,2681.624,23245.436,2679.96,23247.539,2679.96Zm-12.836-3.188h0V2689.6h3.98v-12.825h-3.98Zm1.984-6.374a2.312,2.312,0,1,0,2.3,2.312A2.312,2.312,0,0,0,23236.688,2670.4Z",
    transform: "translate(-23227.92 -2664)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.728a87c687e3ec756a7b7bedae2431d5.svg";
export { ForwardRef as ReactComponent };